<template lang="pug">
  v-stepper(v-model="e1")
    v-snackbar(
      v-model="snackbar"
      :timeout="10000"
      color='error'
    ) {{ snackbarMessage }} 
    v-stepper-header
      v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
      v-divider
      v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
      v-divider
      v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

    v-stepper-items
      v-stepper-content(step="1")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Judul Pekerjaan
              v-flex(xs7 sm5)
                v-text-field(id="fikp-judul-pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
              v-flex(xs1 sm4)

              v-flex(xs3 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Tanggal Perizinan
              v-flex(xs4 sm2)
                v-menu(
                  v-model="startMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="startDate"
                      label="mulai dari"
                      prepend-icon="event"
                      readonly
                      id="fikp-tgl-izin-start"
                      v-on="on")
                  v-date-picker(id="fikp-tgl-picker-start" v-model="startDate" @input="clearDate" :min="todayDate")
              v-flex(xs4 sm2)
                v-menu(
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="endDate"
                      label="sampai dengan"
                      prepend-icon="event"
                      id="fikp-tgl-izin-end"
                      readonly
                      v-on="on")
                  v-date-picker(id="fikp-tgl-picker-end" v-model="endDate" @input="endMenu = false" :min="startDate")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Department / Divisi
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                      class="inputDefault"
                      v-model="deptDivisi"
                      id="fikp-dep-divisi"
                      :items="dataUsers.department"
                      label="Department")
                  v-col
                    v-text-field(id="fikp-divisi" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
              v-flex(xs1 sm4)
              
              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Lokasi Pekerjaan
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                        class="inputDefault"
                        id="fikp-lokasi-kerja"
                        label="Lokasi Pekerjaan" 
                        v-model="lokasi" 
                        :items="locations.data" 
                        no-data-text="No Data" 
                        color="blue-grey lighten-2" 
                        item-text="location_name" 
                        item-value="data" 
                        clearable
                        chips
                        multiple)
                  v-col
                    v-text-field(id="fikp-sub-lokasi" class="inputDefault" v-model='subLokasi' label="Sub Lokasi" counter="100" maxlength="100" height="42")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Perusahaan
              v-flex(xs7 sm5)
                v-autocomplete(
                  class="inputDefault"
                  id="fikp-company"
                  v-model="perusahaan"
                  :items="dataUsers.companies"
                  label="Perusahaan")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Nama Pemegang Izin 1
              v-flex(xs7 sm5)
                v-menu(
                  v-model="searchPemegangMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="pemegangIzin.name"
                      label="Pemegang Izin"
                      id="fikp-pemegang-izin1"
                      readonly
                      v-on="on")
                  PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") Nama Pemegang Izin 2
              v-flex(xs7 sm5)
                v-menu(
                  v-model="searchPemegang2Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="pemegangIzin2.name"
                      label="Pemegang Izin 2"
                      id="fikp-pemegang-izin2"
                      readonly
                      v-on="on")
                  PemegangModal(:searchPemegang="searchPemegang2Menu" @interface="searchPemegang2Menu = false" @selectedUser="updatePemegangIzin2")
              v-flex(xs1 sm4)
        v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="2")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs12 sm12) 
                  h3(class="headerSection") Deskripsi Detail Pekerjaan (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fikp-detail-pekerjaan" :editor="editor" v-model="detailPekerjaan" :config="editorConfig")
                  br

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Potensi Bahaya / Risiko Yang Mungkin Ada
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fikp-petensi-bahaya" :editor="editor" v-model="bahaya" :config="editorConfig")
                  br          
        v-btn(class="mr-3" dark color='blue-grey' @click="backStep();scrollTop();") BACK
        v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="3")
        v-card(class="mb-12"
        height="auto")
          v-layout(row wrap)
            //-Done
            v-flex(xs12 sm12) 
              h3(class="headerSection") Daftar Periksa
              br
            v-flex(xs5 sm6)
              p(class="headerInput") Prosedur kerja (PPO / AKA) ada?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-ppo-aka" class="selectInput" :items='checkOptions' v-model="prosedurKerja" label="Pilih" clearable) 
            
            v-flex(xs5 sm6)
              p(class="headerInput") Personil telah kompeten melaksanakan pekerjaan panas?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-pemrsonil-kompeten" class="selectInput" :items='checkOptions' v-model="PersonilKompeten" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Pengamat kebakaran (Fire Warden) ada sepanjang waktu?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-pengamat" class="selectInput" :items='checkOptions' v-model="pengamatKebakaran" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Ada material mudah terbakar dalam radius 11 meter?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-material" class="selectInput" :items='checkOptions' v-model="materialMudahTerbakar" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Pengujian gas mudah terbakar
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-pengajuan-gas" class="selectInput" :items='checkOptions' v-model="pengujianGas" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") APAR tersedia dan memadai?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-apar" class="selectInput" :items='checkOptions' v-model="APAR" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Area perlu dibasahkan?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-area-dibasahkan" class="selectInput" :items='checkOptions' v-model="areaDibasahkan" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Selimut api (Fire Blanket) diperlukan?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-selimut-api" class="selectInput" :items='checkOptions' v-model="selimutApi" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Rambu memadai dan sudah terpasang?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-rambu-memadai" class="selectInput" :items='checkOptions' v-model="rambuTerpasang" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Area sudah dibarikade?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-area-barikade" class="selectInput" :items='checkOptions' v-model="areaBarikade" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Pemeriksaan api setelah pekerjaan selesai
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-pemeriksaan-api" class="selectInput" :items='checkOptions' v-model="pemeriksaanApi" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Semua potensi percikan di area sudah diidentifikasi?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(id="fikp-potensi" class="selectInput" :items='checkOptions' v-model="potensiPercikan" label="Pilih" clearable) 

            v-flex(xs12 sm12)
              br
            v-flex(xs5 sm3) 
              h3(class="headerSection") Upload Dokumen
            v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
              v-file-input(id="fikp-ducoment" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                template(v-slot:selection="{ text }" )
                  v-chip(small label color="primary")   {{ text }} 
            v-flex(xs6 sm5 class="attachmentName" v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
              span(id="fikp-ducoment") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
              v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                v-icon mdi-close
            v-flex(xs1 sm4)

            v-flex(xs12 sm12)
              br

            v-flex(xs12 sm12) 
                h3(class="headerSection") Pengendalian Risiko Tambahan
                br
            v-flex( sm12)
                div(style="margin: 0 15px 0 15px;padding: 0;}")
                  ckeditor(id="fikp-pengendalian-resiko" :editor="editor" v-model="pengendalianRisikoTambahan" :config="editorConfig")
                br
              
            v-flex(xs4 sm3) 
              p(class="headerSection") Frekuensi Uji Gas
            v-flex(xs7 sm5)
              v-text-field(id="fikp-frekuensi" class="inputDefault" v-model='frekuensiUjiGas')
            v-flex(xs1 sm4)

            v-flex(xs4 sm3) 
              br
              p(class="headerSection") Tanggal
            v-flex(xs7 sm5)
                v-menu(
                  v-model="startMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="tanggalSeksiD"
                      label="Tanggal"
                      prepend-icon="event"
                      id="fikp-tanggal"
                      readonly
                      v-on="on")
                  v-date-picker(id="fikp-tanggal-picker" v-model="tanggalSeksiD" @input="startMenu2 = false")
            v-flex(xs1 sm4)

            v-flex(xs4 sm3) 
              p(class="headerSection") Jam
            v-flex(xs7 sm5)
                v-text-field(id="fikp-jam" prepend-icon="access_time" class="inputDefault" placeholder="HH:mm" hint="HH:mm" v-model='waktuSeksiDMask' v-mask="'##:##'")
            v-flex(xs1 sm4)

            v-flex(xs4 sm3) 
              p(class="headerSection") Maksimum LEL yang diizinkan (5%)
            v-flex(xs7 sm5)
              v-text-field(id="fikp-maksimum-lel" class="inputDefault" v-model='LEL')
            v-flex(xs1 sm4)

            v-flex(xs12 sm12) 
                h3(class="headerSection") Catatan Penting Lainnya
                br
            v-flex( sm12)
                div(style="margin: 0 15px 0 15px;padding: 0;}")
                  ckeditor(id="fikp-catatan-penting" :editor="editor" v-model="catatanPentingLain" :config="editorConfig")
                br
        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(class="mr-3" color='info' @click='submit(1)')
          v-icon insert_drive_file
          | &nbsp; Save as Draft
        v-btn(v-if='!submitClick' color='success' @click='submit(2)')
          v-icon send
          | &nbsp; Submit Request
        v-btn(text @click="backHome()") Cancel
</template>

<script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import PemegangModal from "./PemegangModal.vue";
import { handleError } from "../helper/handleGlobalError.js";
export default {
  name: "AddKerjaPanas",
  components: {
    PemegangModal
  },
  props: {
    edit: { type: Boolean, default: false },
    users: Array,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        removePlugins : ['ImageUpload','MediaEmbed'],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
          styles: [
              // This option is equal to a situation where no style is applied.
              'full',
              // This represents an image aligned to the left.
              'alignLeft',
              // This represents an image aligned to the right.
              'alignRight'
          ]
        }
      },      
      searchPemegangMenu: false,
      searchPemegang2Menu: false,
      judulPekerjaan: '',
      subLokasi: '',
      divisi: '',
      deptDivisi: '',
      perusahaan:'',

      pengendalianRisikoTambahan: '',
      catatanPentingLain: '',
      detailPekerjaan:'',
      bahaya:'',

      pemegangIzin:'',
      pemegangIzin2:'',
      frekuensiUjiGas:'',
      tanggalSeksiD:'',
      waktuSeksiD:'',
      LEL:'',

      checkOptions: ['Ya', 'Tidak'],
      prosedurKerja:'',
      PersonilKompeten: '',
      pengamatKebakaran:'',
      materialMudahTerbakar:'',
      pengujianGas:'',
      areaDibasahkan:'',
      potensiPercikan:'',
      selimutApi:'',
      rambuTerpasang:'',
      areaBarikade:'',
      pemeriksaanApi:'',
      APAR:'',

      snackbar: false,
      snackbarMessage: '',

      e1: 1,
      formCode: 'BIB-HSE-PPO-FRM-036-001',
      todayDate: new Date().toISOString().slice(0,10),
      lokasi: [],

      startDate: null,
      endDate: null,
      startMenu: false,
      endMenu: false,
      startMenu2: false,
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,

      uploadId: null,
      docPendukung: null,
      submitClick: false,
      status: 0,
      rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
      emptyUpload: new File([""], "", {
        type: "",
      })
    };
  },
  mounted: async function() {
    this.$store.dispatch("fetchLocations");
    this.uploadId = Date.now();
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest"]),
    selectedLoc(){
      let tempLoc = []
      let locationCode;

      if(this.dataUsers.location instanceof Array){
        locationCode = this.dataUsers.location[0];
      }else{
        locationCode = this.dataUsers.location;
      }

      for(let i = 0; i < this.lokasi.length; i++){
        tempLoc.push({code: locationCode, name: this.lokasi[i]});
      }
      return tempLoc
    },
    waktuSeksiDMask: {
      get() {
        return this.waktuSeksiD;
      },
      set(value){
        this.waktuSeksiD = this.filterTime(value);
      }
    },
    isPage1Complete: function() {
      return !!this.judulPekerjaan && !!this.deptDivisi && !!this.divisi && !!this.subLokasi && !!this.perusahaan && (this.selectedLoc.length != 0) && !!this.pemegangIzin && !(this.selectedLoc.length<1) && !!this.startDate && !!this.endDate;
    },
  },
  methods: {
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    updatePemegangIzin2(user) {
      this.pemegangIzin2 = user;
    },
    filterTime(value) {
      let temp = value.split('');
      if(parseInt(temp[0]) > 2) {
        temp[0] = "2";
      }
      if(parseInt(temp[1]) > 3 && parseInt(temp[0]) == 2) {
        temp[1] = "3";
      }
      if(parseInt(temp[3]) > 5) {
        temp[3] = "5";
      }
      return temp.join('');
    },
    clearDate(){
      this.endDate=null;
      this.startMenu = false;
    },
    formatDate:helper.formatDate,
    scrollTop(){
      window.scrollTo(0,0);
    },
    submit(status){
      this.submitClick = true;
      this.status = status;

      let formData = new FormData();
      if (this.edit) {
        formData.append('_id', this.dataEditRequest._id);
        formData.append('ipNo', this.dataEditRequest.ipNo);
        formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
      }
      formData.append('ipPemegangIzin', JSON.stringify(this.pemegangIzin));
      if(this.pemegangIzin2){
        formData.append('ipPemegangIzin2', JSON.stringify(this.pemegangIzin2));
      }
      formData.append('ipLocation', JSON.stringify(this.selectedLoc) );
      formData.append('ipSubLokasi', this.subLokasi);
      formData.append('ipJudulPekerjaan', this.judulPekerjaan);
      formData.append('ipDivisi', this.divisi);
      formData.append('ipDeptDivisi', this.deptDivisi);
      formData.append('ipFrekuensiUjiGas',this.frekuensiUjiGas);
      formData.append('ipTanggalSeksiD',this.tanggalSeksiD);
      formData.append('ipWaktuSeksiD',this.waktuSeksiD);
      formData.append('ipLEL',this.LEL);
      formData.append('ipPerusahaan',this.perusahaan);

      formData.append('ipProsedurKerja',this.prosedurKerja || "N/A");
      formData.append('ipPersonilKompeten',this.PersonilKompeten || "N/A");
      formData.append('ipPengamatKebakaran',this.pengamatKebakaran || "N/A");
      formData.append('ipMaterialMudahTerbakar',this.materialMudahTerbakar || "N/A");
      formData.append('ipPengujianGas',this.pengujianGas || "N/A");
      formData.append('ipAPAR',this.APAR || "N/A");
      formData.append('ipAreaDibasahkan',this.areaDibasahkan || "N/A");
      formData.append('ipPotensiPercikan',this.potensiPercikan || "N/A");
      formData.append('ipSelimutApi',this.selimutApi || "N/A");
      formData.append('ipRambuTerpasang',this.rambuTerpasang || "N/A");
      formData.append('ipAreaBarikade',this.areaBarikade || "N/A");
      formData.append('ipPemeriksaanApi',this.pemeriksaanApi || "N/A");
      
      formData.append('ipPengendalianRisikoTambahan',this.pengendalianRisikoTambahan);
      formData.append('ipCatatanPentingLain',this.catatanPentingLain);
      formData.append('ipDetailPekerjaan',this.detailPekerjaan);
      formData.append('ipBahaya',this.bahaya);

      formData.append('ipStatus', this.status);
      formData.append('ipPelaksanaanStart', this.startDate );
      formData.append('ipPelaksanaanEnd', this.endDate );
      formData.append('uploadId', this.uploadId );
      formData.append('ipUser', JSON.stringify(this.dataUsers) );
      formData.append('ipForm', this.formCode);
      
      const config = {
        method: this.edit ? "put" : "post",
        url: `${this.API_URL}/v1/requests`,
        headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
        data: formData
      };
      axios(config).then(res => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      }).catch(error => {
          handleError(error, {
            setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
            showSnackbar: (show) => { this.snackbar = show; },
            disableLoader: () => {
              this.$store.state.loader = false;
            },
          });
          this.submitClick = false;
        });
    },
    // upload(name, paramFile){
    //   if(paramFile == undefined) return ;
    //   if(paramFile.size > 10000000){
    //     paramFile = null;
    //     if(name == 'docPendukung'){
    //       this.docPendukung = this.emptyUpload;
    //     }else if(name == 'docAlat'){
    //       this.docAlat = this.emptyUpload;
    //     }
    //     return
    //   }else{
    //     let formData = new FormData();
    //     formData.append('uploadId', this.uploadId );
    //     formData.append(name, paramFile );
    //     axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
    //   }      
    // },
    deleteDocPendukung(name){
      let id = this.uploadId.toString();      
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    backStep(){
      this.e1--
    },
    docName(name){
      return this.$setFilename(name);
    }
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    dataEditRequest: async function() {
      this.perusahaan = this.dataEditRequest.ipPerusahaan;
      // for (const item of this.locations) {
      //   let checked = false
      //   for (const element of this.dataEditRequest.ipLocation) {
      //     if(item.name == element.name) checked = true
      //   } 
      //   if(checked) this.lokasi.push(true)
      //   else this.lokasi.push(false)
      // }
      this.lokasi = [];
      for(const loc of this.dataEditRequest.ipLocation) {
        this.lokasi.push(loc.name);
      }
      this.subLokasi = this.dataEditRequest.ipSubLokasi;
      this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
      this.pemegangIzin2 = this.dataEditRequest.ipPemegangIzin2 || '';
      this.frekuensiUjiGas = this.dataEditRequest.ipFrekuensiUjiGas;
      this.tanggalSeksiD = this.dataEditRequest.ipTanggalSeksiD;
      this.waktuSeksiD = this.dataEditRequest.ipWaktuSeksiD;
      this.perusahaan = this.dataEditRequest.ipPerusahaan;
      this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
      this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
      this.divisi = this.dataEditRequest.ipDivisi;
      this.LEL = this.dataEditRequest.ipLEL;

      this.prosedurKerja = this.dataEditRequest.ipProsedurKerja;
      this.PersonilKompeten = this.dataEditRequest.ipPersonilKompeten;
      this.pengamatKebakaran = this.dataEditRequest.ipPengamatKebakaran;
      this.materialMudahTerbakar = this.dataEditRequest.ipMaterialMudahTerbakar;
      this.pengujianGas = this.dataEditRequest.ipPengujianGas;
      this.areaDibasahkan = this.dataEditRequest.ipAreaDibasahkan;
      this.potensiPercikan = this.dataEditRequest.ipPotensiPercikan;
      this.selimutApi = this.dataEditRequest.ipSelimutApi;
      this.rambuTerpasang = this.dataEditRequest.ipRambuTerpasang;
      this.areaBarikade = this.dataEditRequest.ipAreaBarikade;
      this.pemeriksaanApi = this.dataEditRequest.ipPemeriksaanApi;
      this.APAR = this.dataEditRequest.ipAPAR;

      this.pengendalianRisikoTambahan = this.dataEditRequest.ipPengendalianRisikoTambahan;
      this.catatanPentingLain = this.dataEditRequest.ipCatatanPentingLain;
      this.detailPekerjaan = this.dataEditRequest.ipDetailPekerjaan;
      this.bahaya = this.dataEditRequest.ipBahaya;
      
      this.startDate = this.formatDate(this.dataEditRequest.ipPelaksanaanStart).slice(0,10);
      this.endDate = this.formatDate(this.dataEditRequest.ipPelaksanaanEnd).slice(0,10);
      this.uploadId = this.dataEditRequest.uploadId;
      this.docPendukung = this.dataEditRequest.ipAttachmentFiles?.docPendukung;
    },
  }
};
</script>

<style>
.ck-editor__editable {
    min-height: 300px;
    max-height: 300px;
    resize:none;
}
.mustFill {
  color: #EA5164;
}
</style>
